import clarity from "@microsoft/clarity";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { I18nProvider } from "@/context/i18n";
import { PermissionsProvider } from "@/context/permissions";
import { SidebarProvider } from "@/context/sidebar";
import { ThemeProvider } from "@/context/theme";

import { ErrorBoundary } from "./components/error-boundary";
import { Loading } from "./components/loading/loading";
import { Toaster } from "./components/ui/toaster";
import { config } from "./config/config";
import { AuthProvider } from "./context/auth";
import { ConfirmDialogProvider } from "./context/confirm-dialog";
import { AppRoutes } from "./routes/app-routes";

function App() {
  const googleClientId = config.googleAuthClientId;

  React.useEffect(() => {
    document.title = config.brandName;
  }, []);

  React.useEffect(() => {
    if (config.clarityId) {
      clarity.init(config.clarityId);
    }
  }, []);

  return (
    <>
      <ErrorBoundary>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <ThemeProvider defaultTheme="light" storageKey="soulhub-theme">
            <GoogleOAuthProvider clientId={googleClientId}>
              <AuthProvider>
                <PermissionsProvider>
                  <I18nProvider>
                    <Loading />
                    <SidebarProvider>
                      <ConfirmDialogProvider>
                        <AppRoutes />
                      </ConfirmDialogProvider>
                      <Toaster />
                    </SidebarProvider>
                  </I18nProvider>
                </PermissionsProvider>
              </AuthProvider>
            </GoogleOAuthProvider>
          </ThemeProvider>
        </Router>
      </ErrorBoundary>
    </>
  );
}

export default App;
